/**
 * AuditSummaryRow - Linha chave/valor usada nos blocos "Resumo" dos modais de
 * auditoria (instâncias e inboxes).
 *
 * Extraído de `InstanceDetailsModal` para permitir reuso sem duplicar estilo.
 *
 * RELEASE:
 *   2026-08-08 v1.0.0 - Extração do subcomponente `SummaryRow`.
 */
import { cn } from '@/lib/utils';

interface AuditSummaryRowProps {
  /** Rótulo curto exibido em caixa alta */
  label: string;
  /** Valor exibido (texto, badge, etc.) */
  value: React.ReactNode;
  /** Aplica fonte mono (ids, códigos) */
  mono?: boolean;
}

export function AuditSummaryRow({ label, value, mono = false }: AuditSummaryRowProps) {
  return (
    <div className="flex flex-col gap-0.5 min-w-0">
      <span className="text-[11px] uppercase tracking-wide text-muted-foreground">
        {label}
      </span>
      <span
        className={cn(
          'text-sm text-foreground truncate',
          mono && 'font-mono text-xs',
        )}
      >
        {value || '—'}
      </span>
    </div>
  );
}
